import React, { useState } from 'react';
import { Table, Button } from 'reactstrap';
import ModalDeleteAccount from 'components/Modals/ModalDeleteAccount';
import ModalFormAccount from 'components/Modals/ModalFormAccount';

const AccountTable = ({ items, updateState, deleteItemFromState, url }) => {
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const toggleDeleteModal = () => setDeleteModal(!deleteModal);

  const handleDelete = async (id) => {
    // Lógica para manejar la eliminación de la cuenta
    deleteItemFromState(id);
    toggleDeleteModal();
  };

  return (
    <Table>
      <thead>
        <tr>
          <th>ID</th>
          <th>Name</th>
          <th>Max Employees</th>
          <th>Max Attribute</th>
          <th>Role</th>
          <th>User ID</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {items.map((item) => (
          <tr key={item.id}>
            <td>{item.id}</td>
            <td>{item.name}</td>
            <td>{item.max_employees}</td>
            <td>{item.max_attr}</td>
            <td>{item.role}</td>
            <td>{item.user_id}</td>
            <td>
              <ModalFormAccount url={url} buttonLabel="Edit" item={item} updateState={updateState} />
              <Button color="danger" onClick={() => { setSelectedItem(item); toggleDeleteModal(); }}>
                Delete
              </Button>
            </td>
          </tr>
        ))}
      </tbody>
      {selectedItem && (
        <ModalDeleteAccount
          isOpen={deleteModal}
          toggle={toggleDeleteModal}
          handleConfirm={() => handleDelete(selectedItem.id)}
          item={selectedItem}
        />
      )}
    </Table>
  );
};

export default AccountTable;